// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import CustomInput from "components/CustomInput/CustomInput";

import {
  SET_TEMPLATE_NAME_ERROR,
  SET_TEMPLATE_DESCRIPTION_ERROR,
  SET_TEMPLATE_NAME_FR,
  SET_TEMPLATE_DESCRIPTION_FR,
  SET_TEMPLATE_POST_DESCRIPTION_FR
} from "actions/types";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  ...customInputStyle
};

class Step2 extends React.Component {
  sendState() {
    return this.state;
  }

  isValidated() {
    const { dispatch, name, description } = this.props;

    let success = true;
    if (!name) {
      dispatch({
        type: SET_TEMPLATE_NAME_ERROR
      });
      success = false;
    }

    if (!description) {
      dispatch({
        type: SET_TEMPLATE_DESCRIPTION_ERROR
      });
      success = false;
    }

    return success;
  }

  render() {
    const {
      dispatch,
      nameErrorMsg,
      descriptionErrorMsg,
      name,
      description,
      postDescription
    } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Nom *"
            id="name-fr"
            formControlProps={{
              fullWidth: true
            }}
            error={nameErrorMsg !== null}
            helperText={nameErrorMsg}
            inputProps={{
              required: true,
              value: name ? name : "",
              onChange: e =>
                dispatch({
                  type: SET_TEMPLATE_NAME_FR,
                  payload: e.target.value
                })
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Description *"
            id="descrption-fr"
            formControlProps={{
              fullWidth: true
            }}
            error={descriptionErrorMsg !== null}
            helperText={descriptionErrorMsg}
            inputProps={{
              value: description ? description : "",
              required: true,
              onChange: e =>
                dispatch({
                  type: SET_TEMPLATE_DESCRIPTION_FR,
                  payload: e.target.value
                }),
              multiline: true,
              rows: 5
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Description après photo"
            id="post-descrption-fr"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value: postDescription ? postDescription : "",
              onChange: e =>
                dispatch({
                  type: SET_TEMPLATE_POST_DESCRIPTION_FR,
                  payload: e.target.value
                }),
              multiline: true,
              rows: 3
            }}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Step2.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = state => {
  const {
    name,
    description,
    postDescription,
    nameErrorMsg,
    descriptionErrorMsg
  } = state.templateReducer;

  return {
    name,
    description,
    postDescription,
    nameErrorMsg,
    descriptionErrorMsg
  };
};

export default connect(mapStateToProps)(withStyles(style)(Step2));
